import { Link } from "react-router";

import { Emblem } from "@/components/brand/Emblem";

export function NotFoundPage() {
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-6 px-4 text-center">
      <Emblem className="size-14" />
      <div>
        <p className="text-label-md uppercase text-primary">Off the map</p>
        <h1 className="mt-2 text-headline-lg">This street doesn't exist in Coal City.</h1>
      </div>
      <Link
        to="/"
        className="rounded-full bg-surface-container-high px-5 py-2.5 text-label-lg uppercase text-primary hover:bg-surface-container-highest"
      >
        Back to base
      </Link>
    </main>
  );
}